import { throttle } from './helpers'

const articleBar = document.querySelector('.main-article-bar')

if (articleBar) {
  window.addEventListener(
    'scroll',
    throttle(() => {
      const position = window.pageYOffset

      if (position > 400) {
        articleBar.classList.add('main-article-bar--active')
      } else {
        articleBar.classList.remove('main-article-bar--active')
      }
    }, 60)
  )
}
